import React, { Component } from 'react';
import PropTypes from 'prop-types';

class PlayButton extends Component {
  _playIcon() {
    return this.props.play ? 'pause' : 'play_arrow';
  }

  render() {
    return (
      <div className='browser-audio-play-button js-play-button' onClick={this.props.togglePlay}>
        <i className='browser-audio-play-icon material-icons'>{this._playIcon()}</i>
      </div>
    );
  }
}

PlayButton.propTypes = {
  play: PropTypes.bool.isRequired,
  togglePlay: PropTypes.func.isRequired
};

export default PlayButton;
